// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unsub-btn{color:#fff;font-size:12px;font-style:normal;font-weight:700;border-radius:10px;background:#ed885c;border:1px solid #ed885c;padding:10px 15px;text-align:center;transition:all .3s ease-in-out;cursor:pointer;margin-top:30px}.unsub-btn:hover{background:transparent;color:#ed885c}.error-find{color:#c10015;font-size:12px}.error-find,.result-message{text-align:center}", ""]);
// Exports
module.exports = exports;
